
<table style="margin-top: 10px;" *ngIf="data.content && data.content.length>0" class="table table-responsive-sm show_dk_data">
	<thead>
		<tr class="table-primary" style="font-size:18px;">
			<th *ngFor="let attribute of data.attribute" (click)="sort_fn(attribute.key,attribute.sort)" [ngClass]="attribute.title_cls_dk"
			class="{{(attribute.sort)?'sorting':''}} {{(data.sort_obj==undefined || data.sort_obj.column != attribute.key)?'':data.sort_obj.sort == '0'?'sorting_asc':'sorting_desc'}}"
			>{{attribute.title}}</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let content of data.content;let i = index;">
			<td *ngFor="let attribute of data.attribute">
				<div *ngIf="attribute.type=='txt'" [ngClass]="attribute.type_cls_dk">{{content[attribute.key]}}</div>
				<div *ngIf="attribute.type=='html'" [innerHTML]="content[attribute.key]" [ngClass]="attribute.type_cls_dk"></div>
				<div *ngIf="attribute.type=='num'" [ngClass]="attribute.type_cls_dk">{{content[attribute.key]|number}}{{attribute.unit}}</div>
				<img *ngIf="attribute.type=='img'" [ngClass]="attribute.type_cls_dk" [src]="content[attribute.key]">
				<ng-container
					*ngIf="operationTemplateRef_dk && attribute.type=='opt'"
					[ngTemplateOutlet]="operationTemplateRef_dk"
					[ngTemplateOutletContext]="{$implicit:{idx: i, key:attribute.key}}"
				>
				</ng-container>
			</td>
		</tr>
	</tbody>
</table>

<header class="bs-docs-nav navbar navbar-static-top" id="top"></header>
<a *ngIf="showbacktop"  (click)="go_top()" id="go_top" onclick="return false" class="back-to-top show_mb_data"> <i style="font-size: 1.73em;" class="fas fa-arrow-circle-up"></i> </a>

<div *ngIf="showsortool" >
	<select class="form-control show_mb_data"
	[(ngModel)]="sort_obj.column"
	(change)="apply_it()"
	>
		<ng-container *ngFor="let attribute of data.attribute" >
			<option *ngIf="attribute.sort==1" [ngValue]="attribute.key">{{attribute.title}}</option>
		</ng-container>
	</select>
	<select class="form-control show_mb_data"
	[(ngModel)]="sort_obj.sort"
	(change)="apply_it()"
	>
		<option *ngFor="let item of order_list_for_mb" [ngValue]="item.id">{{item.name}}</option>
	</select>
</div>
<div class="card-deck" *ngIf="data.content && data.content.length>0">
	<div class="card show_mb_data" *ngFor="let content of data.content;let i = index;">
		<div class="card-body">
			<div *ngFor="let attribute of data.attribute">
				<img *ngIf="attribute.type=='img'" class="card-img-top" [ngClass]="attribute.type_cls_mb" [src]="content[attribute.key]" alt="Card image cap">
				<div *ngIf="attribute.type=='txt'" class="card-text show_mb_item">
					<div [ngClass]="attribute.title_cls_mb">{{attribute.title}}：</div>
					<div [ngClass]="attribute.type_cls_mb">{{content[attribute.key]}}</div>
				</div>
				<div *ngIf="attribute.type=='html'" class="card-text show_mb_item">
					<div [ngClass]="attribute.title_cls_mb">{{attribute.title}}：</div>
					<div [ngClass]="attribute.type_cls_mb" [innerHTML]="content[attribute.key]"></div>
				</div>
				<div *ngIf="attribute.type=='num'" class="card-text show_mb_item">
					<div [ngClass]="attribute.title_cls_mb">{{attribute.title}}：</div>
					<div [ngClass]="attribute.type_cls_mb">{{content[attribute.key]|number}}{{attribute.unit}}</div>
				</div>
				<div *ngIf="attribute.type=='opt'" class="card-text show_mb_item">
					<div [ngClass]="attribute.title_cls_mb">{{attribute.title}}：</div>
					<ng-container
						*ngIf="operationTemplateRef_mb"
						[ngTemplateOutlet]="operationTemplateRef_mb"
						[ngTemplateOutletContext]="{$implicit:{idx: i, key:attribute.key}}"
						>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!data.content || data.content.length==0">無資料</div>

